import * as React from 'react';
import type { MenuData } from "../../../js/data/menuData.ts";
import Logo from "./logo.tsx";
import LogoFooter from "./logoFooter.tsx";
import MenuItem, { filterMenuItemsByParent } from "./menuItem.tsx";

type Props = {
	menu: MenuData,
	pathname: string,
}

const Footer = ({menu, pathname, ...otherProps}: Props) => {

	const rootMenuItems = filterMenuItemsByParent(menu, null);

	return (<>
		<div id="footerWrapper" className="bg-primary-500 text-white">
			<footer className="max-w-screen-2xl mx-auto px-8 md:px-10 xl:px-20 pt-24 pb-8">

				<div className="flex flex-wrap lg:flex-nowrap justify-stretch items-start gap-8 mb-12 lg:mb-32">

					<div className="w-full lg:w-1/3 justify-center lg:justify-start order-1">
						<ul className="menuFooter list-none m-0 pl-0 columns-1 xl:columns-2 text-center lg:text-left text-sm">
							{rootMenuItems?.map((item, index) => {
								return <MenuItem
									classNameAnchor="no-underline"
									menu={menu}
									item={item}
									key={'item' + index}
									pathname={pathname}
									index={index}
									siblingsCount={rootMenuItems.length - 1}
								/>;
							})}
						</ul>
					</div>

					<div className="w-full lg:w-1/3 flex flex-col gap-4 justify-center items-center order-3 lg:order-2 mt-20 lg:mt-0">
						<Logo className="white"/>
						<div className="text-center text-sm">AUTOMOTIVE EVENT STAFFING ON DEMAND</div>
					</div>

					<div className="w-full lg:w-1/3 flex justify-center lg:justify-end leading-loose order-2 lg:order-3">
						<div className="text-center lg:text-left">
							<div className="flex justify-between gap-2">
								{/*<a href="#">*/}
								{/*	<img src="/images/logo/logo_tiktok.svg" alt="TikTok" width="21" height="25"/>*/}
								{/*</a>*/}
								<a href="https://www.linkedin.com/company/amci-europe" className="mr-4" target="_blank">
									<img src="/images/logo/logo_in.svg" alt="Linked In" width="25" height="24"/>
								</a>
								<a href="https://www.facebook.com/p/AMCI-Europe-61576571054672/" target="_blank" className="mr-4">
									<img src="/images/logo/logo_fb.svg" alt="Facebook" width="24" height="25"/>
								</a>
								<a href="https://www.instagram.com/amci_europe/" target="_blank">
									<img src="/images/logo/logo_insta.svg" alt="Instagram" width="24" height="24"/>
								</a>
								{/*<a href="#">*/}
								{/*	<img src="/images/logo/logo_x.svg" alt="Facebook" width="24" height="24"/>*/}
								{/*</a>*/}
							</div>
						</div>
					</div>
				</div>

				<div className="w-full flex flex-wrap justify-between items-center gap-4 text-xs border-t-white border-t pt-8">
					<div className="text-center md:text-left">
						<b>
							&copy; {new Date().getFullYear()} TALENT BY AMCI.
						</b>&nbsp;
						 Building 90, Main Stores, Bicester Motion, Buckingham Road, OX27 8AL, United Kingdom
					</div>
					<div className="text-center md:text-right">
						DESIGNED BY HALLO DIGITAL
					</div>
				</div>
			</footer>
		</div>

		{/*<div id="cookieWarning">*/}
		{/*	<p>*/}
		{/*		In order to provide you with the best online experience this website uses cookies.*/}
		{/*		By using our website, you agree to our use of cookies.*/}
		{/*	</p>*/}
		{/*	<a id="cookieClose" className="close" href="#close" title="X"><i className="icon-before fa-icon icon-times"></i></a>*/}
		{/*</div>*/}
	</>);
}

export default Footer;
